import { StyleSheet } from "@react-pdf/renderer";

export const baseLiveResumeStyles = StyleSheet.create({
  verticalFlex: {
    display: "flex",
    flexDirection: "column",
  },
  horizontalFlex: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  centredFlex: {
    alignItems: "center",
    justifyContent: "center",
    gap: 12
  },
  page: {
    padding: 30,
    backgroundColor: "white",
  },
  justifyBetween: {
    justifyContent: "space-between",
  },
});

export const liveResumeStyles = StyleSheet.create({
  rowContainer: {
    flex: 1,
    ...baseLiveResumeStyles.horizontalFlex,
  },
  fullWidthSection: {
    width: "100%",
    ...baseLiveResumeStyles.verticalFlex,
  },
  columnContainer: {
    ...baseLiveResumeStyles.verticalFlex,
    width: "100%",
  },
});

export const liveProfileStyles = StyleSheet.create({
  profileWrapper: {
    textAlign: "center",
  },
  link: {
    fontFamily: "Lato",
    fontSize: 10,
    color: "black",
    textDecoration: "none",
    alignSelf: "flex-end",
    justifySelf: "flex-end",
  },
  body: {
    fontSize: 10,
    color: "black",
    textDecoration: "none",
    alignSelf: "flex-end",
    justifySelf: "flex-end",
  },
});

export const liveSectionStyles = StyleSheet.create({
  sectionContainer: {
    marginBottom: 10,
  },
  withDatesWrapper: {
    ...baseLiveResumeStyles.horizontalFlex,
    width: "100%",
    justifyContent: "space-between",
  },
  withDatesLeftContent: {
    width: "70%",
    ...baseLiveResumeStyles.verticalFlex,
  },
  withDatesRightContent: {
    display: "flex",
    flexDirection: "column",
    width: "30%",
    textAlign: "right",
  },
});